import { memo } from 'react';
import { object, bool, func, array, instanceOf, number, arrayOf } from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { DayPicker } from '../index';
import { DatepickerPromo } from './DatepickerPromo';
import { DatepickerTabs } from './Styled';
import { isRTpromoShown } from '../../../../constants/settings';
const datesRange = {
  from: null,
  to: null
};
const DayPickerTabs = ({
  tabs,
  selectedTab,
  onSelect,
  onDayChangeRange,
  onDayChangeSingle,
  selectedDaysRange = datesRange,
  selectedDaysSingle,
  initialMonthRange,
  initialMonthSingle,
  numberOfMonths,
  disabledDays,
  allowDates,
  modifiers,
  hasWeekDays,
  hasMonthControls,
  isMobile,
  isTicketSearch,
  OverlayComponent,
  onCloseModal,
  AttentionComponent,
  isSelectedDatepickerRange
}) => {
  const {
    from,
    to
  } = selectedDaysRange;
  const groupProps = {
    numberOfMonths,
    disabledDays,
    allowDates,
    modifiers,
    hasMonthControls,
    hasWeekDays,
    isMobile,
    OverlayComponent,
    onCloseModal,
    AttentionComponent,
    isSelectedDatepickerRange,
    isTicketSearch
  };
  const renderTabPanel = type => {
    switch (type) {
      case 'single':
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DayPicker, {
          onDayClick: onDayChangeSingle,
          selectedDays: selectedDaysSingle,
          initialMonth: initialMonthSingle,
          ...groupProps
        }));
      case 'range':
        return /*#__PURE__*/React.createElement(DayPicker, {
          isRange: true,
          onDayClick: onDayChangeRange,
          selectedDays: [from, {
            from,
            to
          }],
          initialMonth: initialMonthRange,
          ...groupProps
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement(DatepickerTabs, null, /*#__PURE__*/React.createElement(Tabs, {
    selectedIndex: tabs.indexOf(selectedTab),
    onSelect: onSelect
  }, /*#__PURE__*/React.createElement(TabList, null, tabs.map(({
    title,
    key
  }) => /*#__PURE__*/React.createElement(Tab, {
    key: key
  }, title, isRTpromoShown && key === 'range' && /*#__PURE__*/React.createElement(DatepickerPromo, {
    caption: I18n.t('pages.search.round_trip.datepicker.promo'),
    isMobile: isMobile
  })))), tabs.map(({
    key
  }) => /*#__PURE__*/React.createElement(TabPanel, {
    key: key
  }, renderTabPanel(key)))));
};
DayPickerTabs.propTypes = {
  tabs: arrayOf(object),
  selectedTab: object,
  onSelect: func,
  onDayChangeRange: func,
  onDayChangeSingle: func,
  selectedDaysRange: object,
  selectedDaysSingle: instanceOf(Date),
  initialMonthRange: instanceOf(Date),
  initialMonthSingle: instanceOf(Date),
  numberOfMonths: number,
  disabledDays: array,
  allowDates: array,
  modifiers: object,
  hasWeekDays: bool,
  hasMonthControls: bool,
  isMobile: bool,
  isTicketSearch: bool,
  OverlayComponent: func,
  onCloseModal: func,
  AttentionComponent: func,
  isSelectedDatepickerRange: bool
};
export default /*#__PURE__*/memo(DayPickerTabs);